var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Play_Icon",
    "data-name": "Play Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 183.452,
    height: 183.67,
    viewBox: "0 0 183.452 183.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4431",
    "data-name": "Rectangle 4431",
    width: 183.452,
    height: 183.67,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10226",
    "data-name": "Group 10226",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34794",
    "data-name": "Path 34794",
    d: "M0,99.359V84.294c.12-.173.323-.335.348-.522.38-2.776.7-5.56,1.1-8.334a77.065,77.065,0,0,1,6.49-21.32,90.933,90.933,0,0,1,25.322-33.1A95.164,95.164,0,0,1,48.542,10.739,83.672,83.672,0,0,1,67.677,3.265c3.653-.907,7.39-1.471,11.09-2.19L84.294,0H98.642c.114.111.217.3.345.321,3.337.5,6.687.932,10.016,1.482a85.7,85.7,0,0,1,21.964,7.028,89.533,89.533,0,0,1,22.374,14.911,93.1,93.1,0,0,1,13.864,15.825A89.833,89.833,0,0,1,181.08,70.609a101.859,101.859,0,0,1,2.154,13.6,62.715,62.715,0,0,1,.018,10.213c-.31,4.791-.773,9.582-1.417,14.339a77.423,77.423,0,0,1-6.9,22.02,94.422,94.422,0,0,1-27.915,34.37,92.078,92.078,0,0,1-19.6,11.335,89.182,89.182,0,0,1-30.13,7.069,101.523,101.523,0,0,1-17.2-.708,89.717,89.717,0,0,1-14.794-3A88.189,88.189,0,0,1,29.4,159.294a95.571,95.571,0,0,1-11.655-13.105A88.084,88.084,0,0,1,.707,103.553c-.165-1.406-.468-2.8-.707-4.194m87.945,72.92c26.815-.039,46.876-8.752,62.926-26.086,16.14-17.43,22.975-38.357,20.905-61.966A76.549,76.549,0,0,0,150.662,37.2c-18.147-19.166-40.62-27.518-66.84-25.335A75.485,75.485,0,0,0,36.837,33.058C18.486,50.64,9.743,72.3,11.518,97.821a77.483,77.483,0,0,0,22.413,49.894c15.562,15.993,34.636,24.3,54.014,24.564",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34795",
    "data-name": "Path 34795",
    d: "M144.6,189.787c-.018-8.306-.052-16.611-.049-24.917q.008-22.678.049-45.356l.154.008.149-.039c4.165,2.338,8.353,4.64,12.492,7.023,6.647,3.827,13.262,7.71,19.892,11.565q9.806,5.7,19.62,11.393c2.945,1.7,5.928,3.337,9.166,5.155-1.848,1.082-3.543,2.08-5.243,3.069q-14.584,8.479-29.172,16.949Q159.452,181.7,147.2,188.693c-.739.423-1.534.752-2.3,1.124a.5.5,0,0,0-.3-.031",
    transform: "translate(-76.004 -62.824)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconWhite);
export default __webpack_public_path__ + "static/media/Play_Icon_white.1270eb122a8dc3482a5bd26f6c1fb572.svg";
export { ForwardRef as ReactComponent };